import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-forward-up', 'ArrowForwardUp', [["path",{"d":"M15 14l4 -4l-4 -4"}],["path",{"d":"M19 10h-11a4 4 0 1 0 0 8h1"}]]);